import type { Line } from "./base";

const SCROLL_KEY = Symbol("scrollRegion");

export type ScrollRegionMeta = {
  onScroll: (offset: number) => void;
  totalLines: number;
  maxHeight: number;
  offset: number;
};

type ScrollTaggedLine = Line & { [SCROLL_KEY]?: ScrollRegionMeta };

function toTagged(line: Line): ScrollTaggedLine {
  return line as ScrollTaggedLine;
}

export function markScrollRegion(line: Line, meta: ScrollRegionMeta): Line {
  toTagged(line)[SCROLL_KEY] = meta;
  return line;
}

export function getScrollRegionMeta(line: Line): ScrollRegionMeta | undefined {
  return toTagged(line)[SCROLL_KEY];
}

export function preserveScrollTag(source: Line, target: Line): void {
  const meta = toTagged(source)[SCROLL_KEY];
  if (meta) toTagged(target)[SCROLL_KEY] = meta;
}
